/*
 * @Author: your name
 * @Date: 2021-08-04 15:25:39
 * @LastEditTime: 2021-12-04 16:59:13
 * @LastEditors: lks
 * @Description: In User Settings Edit
 */
import { RouteConfig } from "vue-router";
import PView from "../layouts/view.vue";
let coinName: any = "龙艺币";
switch (window.location.hostname) {
  case "www.longyixiu.com":
  case "longyixiu.com":
    coinName = "龙艺币";
    break;
  case "www.wenjuanjia.com":
  case "wenjuanjia.com":
  case "192.168.1.138":
    coinName = "问卷币";
    break;
  default:
    coinName = "龙艺币";
    break;
}
const taskRoute: RouteConfig[] = [
  // {
  //   path: '/task',
  //   component: PView,
  //   redirect: '/task.html',
  //   children: [
  {
    path: "/task.html",
    name: "task",
    component: () => import("@/views/taskCenter/index.vue"),
    meta: { title: "任务有礼", parentTab: "task" },
  },
  // ],
  // },
  {
    path: "/coinRule.html",
    name: "coinRule",
    component: () => import("@/views/taskCenter/coinRule.vue"),
    meta: { title: `${coinName}规则及常见内容`, parentTab: "task" },
  },
  {
    path: "/coinList.html",
    name: "coinList",
    component: () => import("@/views/taskCenter/coinList.vue"),
    meta: { title: `${coinName}及优惠券明细`, parentTab: "task" },
  },
  {
    path: "/giftList.html",
    name: "giftList",
    component: () => import("@/views/taskCenter/giftList.vue"),
    meta: { title: "兑换记录", parentTab: "task" },
  },
];
export { taskRoute };
